import type { PostHog } from 'posthog-js';
import { PostHogEventEnum } from '@/Domain/enum/PostHogEvent.enum';

export const capturePostHogSafely = (
  postHog: Pick<PostHog, 'capture'>,
  event: PostHogEventEnum,
  properties?: Record<string, unknown>,
): void => {
  try {
    if (properties) {
      postHog.capture(event, properties);
    } else {
      postHog.capture(event);
    }
  } catch (error) {
    console.error(`Failed to capture PostHog event ${event}`, error);
  }
};

export const getPostHogFeatureFlagSafely = (
  postHog: Pick<PostHog, 'getFeatureFlag'>,
  featureFlag: string,
): ReturnType<PostHog['getFeatureFlag']> => {
  try {
    return postHog.getFeatureFlag(featureFlag);
  } catch (error) {
    console.error(`Failed to read PostHog feature flag ${featureFlag}`, error);
    return undefined;
  }
};
